import { IChangePropertyPayload } from '@dash/editForm';
import actionsTypes from './actionTypes';
import {
  ChangeModalVisibilityAction,
  ChangePropertyAction,
  ClearStateAction,
  LoadFormInfoSuccessAction,
  ProcessActionErrorAction,
  ProcessActionRequestAction,
  ProcessActionSuccessAction,
} from './actions.d';
import {
  Attribute,
  IFieldTypes,
  IChangeModalVisibilityPayload,
  IProcessRequestPayload,
  ILoadFormInfoSuccessPayload,
} from './types';

const actions = {
  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),

  loadFormInfoSuccess: (payload: ILoadFormInfoSuccessPayload): LoadFormInfoSuccessAction => ({
    type: actionsTypes.LOAD_FORM_INFO_SUCCESS,
    payload,
  }),

  changeProperty: (payload: IChangePropertyPayload<Attribute, IFieldTypes>): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  changeModalVisibility: (payload: IChangeModalVisibilityPayload): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
    payload,
  }),

  clearState: (): ClearStateAction => ({
    type: actionsTypes.CLEAR_STATE,
  }),
};

export default actions;
